import React from "react";
import { useApiData } from "../../hooks/useApiData";
import { unwrapArray } from "../../utils/api";
import Card from "../ui/Card";
import { IconTrophy } from "../ui/icons";
import { ListSkeleton } from "../ui/Skeleton";
import { EmptyState, ErrorState } from "../ui/StateBlock";
import { formatNumber } from "./chartTheme";

/** Top 20 items by value with the share of the period revenue (share of the listed items' sum is NOT used: the real total is passed in). */
export default function TopItemsList({ startDate, endDate, warehouse, totalRevenue }) {
  const { data: raw, loading, error } = useApiData(
    startDate && endDate ? `/top_items.php?od=${startDate}&do=${endDate}&limit=20${warehouse ? `&warehouse=${warehouse}` : ""}` : null
  );
  const rows = unwrapArray(raw);
  const base = Number(totalRevenue) > 0 ? Number(totalRevenue) : rows.reduce((s, r) => s + (Number(r.vrednost) || 0), 0);

  return (
    <Card title="Top 20 artikala" icon={IconTrophy}>
      {error && rows.length === 0 ? (
        <ErrorState />
      ) : loading && rows.length === 0 ? (
        <ListSkeleton rows={8} />
      ) : rows.length === 0 ? (
        <EmptyState title="Nema prodaje u izabranom periodu" />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 text-left text-xs text-slate-500 dark:border-slate-800 dark:text-slate-400">
                <th className="py-2 pr-2 font-medium">Br.</th>
                <th className="py-2 pr-2 font-medium">Artikal</th>
                <th className="py-2 pr-2 text-right font-medium">Količina</th>
                <th className="py-2 pr-2 text-right font-medium">Vrednost (RSD)</th>
                <th className="py-2 text-right font-medium">Udeo</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={`${r.artikal}-${i}`} className="border-b border-slate-100 last:border-0 dark:border-slate-800/60">
                  <td className="py-2 pr-2 tabular-nums text-slate-500 dark:text-slate-400">{i + 1}.</td>
                  <td className="py-2 pr-2 text-slate-800 dark:text-slate-100">{r.artikal}</td>
                  <td className="py-2 pr-2 text-right tabular-nums">{formatNumber(r.komada, 2)}</td>
                  <td className="py-2 pr-2 text-right font-medium tabular-nums">{formatNumber(r.vrednost)}</td>
                  <td className="py-2 text-right tabular-nums text-slate-600 dark:text-slate-300">
                    {base > 0 ? `${((Number(r.vrednost) / base) * 100).toLocaleString("sr-RS", { maximumFractionDigits: 1 })}%` : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
